export default __webpack_public_path__ + "static/media/message-bubbles.0969ab86.svg";